module.exports = __webpack_public_path__ + "static/img/1fa2f6e278f59da1b11500fdac0f7a9.4317892.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/1fa2f6e278f59da1b11500fdac0f7a9.jpg
// module id = j2VR
// module chunks = 3